import { DraggableWidget } from '@/components/ui/DraggableWidget'
import { useAircall } from './useAircall'

/**
 * Container the SDK injects its iframe into. Mounted ONCE at the layout
 * level so React Router navigation never tears it down — that would lose
 * the in-call WebRTC state.
 *
 * Wrapped in DraggableWidget: staff can drag it out of the way and the spot
 * persists. Expanded/collapsed is a visibility toggle so the iframe (and any
 * live call) survives underneath.
 */
export function AircallWidget() {
  const ctx = useAircall()
  if (!ctx) return null
  // Don't even mount the iframe container when the integration is gated off
  // — the SDK is never instantiated in that branch, so this div would just
  // be dead weight in the DOM.
  if (ctx.status === 'disabled') return null
  return (
    <DraggableWidget name="aircall" width={400} height={600} visible={ctx.expanded} onHide={ctx.collapse}>
      <div id={ctx.widgetContainerId} style={{ width: '100%', height: '100%' }} />
      <style>{`
  #${ctx.widgetContainerId} iframe {
    border: none;
    width: 400px !important;
    height: 600px !important;
  }
`}</style>
    </DraggableWidget>
  )
}
